/**
 * 排序工具函数
 * 用于拖拽排序时的 ordinal 计算
 */

const BASE_GAP = 1000;
const MIN_SAFE_GAP = 10;
const URGENT_GAP = 5;

/**
 * 计算动态 ordinal 值
 * @param {number} index - 新位置索引
 * @param {Array} list - 数据列表
 * @param {string} direction - 排序方向，'desc' 或 'asc'，默认 'desc'
 * @returns {number|null} - 新的 ordinal 值，如果无法计算则返回 null
 */
export const calculateDynamicOrdinal = (index, list, direction = "desc") => {
  const length = list.length;
  if (length === 1) return BASE_GAP * length;

  // 拖到首位
  if (index === 0) {
    return direction === "desc"
      ? list[1].ordinal + BASE_GAP
      : list[1].ordinal - BASE_GAP;
  }

  // 拖到最后
  if (index === length - 1) {
    return direction === "desc"
      ? list[length - 2].ordinal - BASE_GAP
      : list[length - 2].ordinal + BASE_GAP;
  }

  // 拖到中间
  const prev =
    (list[index - 1] && list[index - 1].ordinal) ||
    (direction === "desc" ? BASE_GAP * length : BASE_GAP);
  const next =
    (list[index + 1] && list[index + 1].ordinal) ||
    (direction === "desc" ? BASE_GAP : BASE_GAP * length);

  const gap = direction === "desc" ? prev - next : next - prev;

  if (gap > MIN_SAFE_GAP) {
    return Math.floor((prev + next) / 2);
  } else if (gap > URGENT_GAP) {
    const conservativeGap = Math.max(URGENT_GAP, Math.floor(gap / 5));
    return direction === "desc"
      ? prev - conservativeGap
      : prev + conservativeGap;
  }
  return null;
};

/**
 * 重排 ordinal
 * @param {Object} options - 配置选项
 * @param {Array} options.dataList - 数据列表
 * @param {number} options.page - 页码，默认 1
 * @param {number} options.pageSize - 每页大小
 * @param {string} options.direction - 排序方向，'desc' 或 'asc'，默认 'desc'
 * @returns {Array} - 重排后的数据列表
 */
export const resetDataOrdinal = ({
  dataList,
  page = 1,
  pageSize,
  direction = "desc"
}) => {
  const list = [...dataList];
  const effectivePageSize = pageSize || list.length;
  const PAGE_GAP = BASE_GAP * effectivePageSize * 2;
  const start = page * PAGE_GAP;

  return list.map((item, index) => ({
    ...item,
    ordinal:
      direction === "desc" ? start - index * BASE_GAP : start + index * BASE_GAP
  }));
};

